import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "@sdge-store/store";

export const selectProgramsSummary = createSelector(
  (state: RootState) => ({
    programs_summary: state.programsSlice.programs_summary,
  }),
  (state) => state
);
